import { ActionStatus } from '../../constants/api';
import CreateAction from '../../utils/actions';




export const SEND_OTP = CreateAction<{ phone: string }>('SEND_OTP');
export const VERIFY_OTP = CreateAction<{ userId: string; password: string }>('VERIFY_OTP');
export const CLEAR_TOKEN = CreateAction<void>('CLEAR_TOKEN');

export interface LoginState {
	VERIFY_OTP_STATUS: ActionStatus;
	SEND_OTP_STATUS: ActionStatus;
  phone: string;
  errorMessage?: string; 
  errorMessageValidate?: string; 
  verificationToken?: any;
}